import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedUser() !== null;
};

// Register Method
export const postFakeRegister = (data: any) => api.create(url.POST_FAKE_REGISTER, data);

// Login Method
export const postFakeLogin = (data: any) => api.create(url.POST_FAKE_LOGIN, data);

// postForgetPwd
export const postFakeForgetPwd = (data: any) => api.create(url.POST_FAKE_PASSWORD_FORGET, data);

// Edit profile
export const postJwtProfile = (data: any) => api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postFakeProfile = (data: any) => api.create(url.POST_EDIT_PROFILE, data);
// export const postFakeProfile = (data: any) => api.update(url.POST_EDIT_PROFILE + '/' + data.idx, data);

// Register Method
export const postJwtRegister = (url: any, data: any) => {
  return api.create(url, data)
    .catch((err: any) => {
      var message;
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 404:
            message = "Sorry! the page you are looking for could not be found";
            break;
          case 500:
            message = "Sorry! something went wrong, please contact our support team";
            break;
          case 401:
            message = "Invalid credentials";
            break;
          default:
            message = err[1];
            break;
        }
      }
      throw message;
    });
};
// Login Method
export const postJwtLogin = (data: any) => api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = (data: any) => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = (data: any) => api.create(url.SOCIAL_LOGIN, data);

// Customers
export const getCustomerList = (params : any) => api.get(url.GET_CUSTOMER_LIST, params);
export const addCustomerList = (data: any) => api.create(url.ADD_CUSTOMER_LIST, data);
export const updateCustomerList = (id: string, data: any) => api.update(`${url.UPDATE_CUSTOMER_LIST}${id}`, data);
export const deleteCustomerList = (id: string) => api.delete(`${url.DELETE_CUSTOMER_LIST}${id}`);

// TypeCustomer
export const getTypeCustomers = () => api.get(url.GET_TYPECUSTOMER_LIST);

// Addresses
export const getAddressList = () => api.get(url.GET_ADDRESS_LIST);
export const addAddressList = (data: any) => api.create(url.ADD_ADDRESS_LIST, data);
export const getAddressesByCustomerId = (customerId: string) => {
  return api.get(url.GET_ADDRESSES_BY_CUSTOMER_ID(customerId));
};
//Type Address
export const getTypeAddressList = () => api.get(url.GET_TYPEADDRESS_LIST);

//Type Address
export const getPhoneNumberList = () => api.get(url.GET_PHONENUMBER_LIST);

// Ubicaciones
export const getCountries = () => api.get(url.GET_COUNTRIES);
export const getDepartmentsByCountry = (countryId: string) =>
  api.get(url.GET_DEPARTMENTS_BY_COUNTRY, { countryId });
export const getMunicipalitiesByDepartment = (departmentId: string) =>
  api.get(url.GET_MUNICIPALITIES_BY_DEPARTMENT, { departmentId });


// Wallets
export const getWalletList = () => api.get(url.GET_WALLET_LIST);
export const addWallet = (data: any) => api.create(url.ADD_WALLET, data);
export const updateWallet = (id: string, data: any) => api.update(`${url.UPDATE_WALLET}${id}`, data);
export const deleteWallet = (id: string) => api.delete(`${url.DELETE_WALLET}${id}`);
export const getWalletListNotVirtual = (isVirtualWallet : boolean) => api.get(url.GET_WALLET_NOT_VIRTUAL, {isVirtualWallet});

// Transactions
export const getTransactionsList = (params : any) => api.get(url.GET_TRANSACTIONS_LIST, params);

// Expenses Categories
export const getExpenseCategoryList = () => api.get(url.GET_EXPENSE_CATEGORY_LIST);
export const addExpenseCategory = (data: any) => api.create(url.ADD_EXPENSE_CATEGORY, data);
export const updateExpenseCategory = (id: string, data: any) => api.update(`${url.UPDATE_EXPENSE_CATEGORY}${id}`, data);
export const deleteExpenseCategory = (id: string) => api.delete(`${url.DELETE_EXPENSE_CATEGORY}${id}`);

// Expenses
export const getExpenseList = (params : any) => api.get(url.GET_EXPENSE_LIST, params);
export const addExpense = (data: any) => api.create(url.ADD_EXPENSE, data);
export const updateExpense = (id: string, data: any) => api.update(`${url.UPDATE_EXPENSE}${id}`, data);
export const deleteExpense = (id: string) => api.delete(`${url.DELETE_EXPENSE}${id}`);

// Loans
export const getLoanList = (params : any) => api.get(url.GET_LOAN_LIST, params);
export const getLoan = (id: string) => api.get(`${url.GET_LOAN}${id}`);
export const getLoanStatement = (id: string) =>
  api.get(`${url.GET_LOAN_STATEMENT}${id}`, {}, { responseType: 'blob' });

//Loan Payments
export const getLoanPaymentList = (params: any) => api.get(url.GET_LOAN_PAYMENT_LIST, params);
export const getLoanPaymentDateList = (params: any) => api.get(url.GET_LOAN_PAYMENTDATE_LIST, params);
export const getLoanPaymentByCodeAndLoanId = (params: any) => api.get(url.GET_LOAN_PAYMENT_BY_CODE_AND_LOANID, params);
export const addLoanPayment = (data: any) => api.create(url.ADD_LOAN_PAYMENT, data);
export const updateLoanPayment = (id: string, data: any) => api.update(`${url.UPDATE_LOAN_PAYMENT}${id}`, data);
export const deleteLoanPayment = (id: string) => api.delete(`${url.DELETE_LOAN_PAYMENT}${id}`);
export const getLoanPaymentReceiptPDF = (id: string) =>
  api.get(`${url.GET_REPORT_LOAN_PAYMENT_PDF}${id}`, {}, { responseType: 'blob' });
export const getLoanPaymentReportXLS = (params: any) =>
  api.get(url.GET_REPORT_LOAN_PAYMENT_XLS, params, { responseType: 'blob' });

export const getLoanGeneralReportXLS = (params:any) =>
  api.get(url.GET_REPORT_LOANS_GENERAL_XLS, params, { responseType: 'blob' });

export const getLoanPaymentReportByDatetXLS = (params: any) =>
  api.get(url.GET_REPORT_LOAN_PAYMENT_DATE_XLS, params, { responseType: 'blob' });

export const getExpensesAndIncomesReportByDatetXLS = (params: any) =>
  api.get(url.GET_REPORT_EXPENSES_INCOMES_DATE_XLS, params, { responseType: 'blob' });

// Loan Payment Status
export const getLoanPaymentStatusList = () => api.get(url.GET_LOAN_PAYMENT_STATUS_LIST);

//Loan Application
export const getLoanApplicationList = (params : any) => api.get(url.GET_LOAN_APPLICATION_LIST, params);
export const addLoanApplication = (data: any) => api.create(url.ADD_LOAN_APPLICATION, data);
export const updateLoanApplication = (id: string, data: any) => api.update(`${url.UPDATE_LOAN_APPLICATION}${id}`, data);

//Credit Destination
export const getCreditDestinationList = () => api.get(url.GET_CREDIT_DESTINATION_LIST);
export const addCreditDestination = (data: any) => api.create(url.ADD_CREDIT_DESTINATION, data);
export const updateCreditDestination = (id: string, data: any) => api.update(`${url.UPDATE_CREDIT_DESTINATION}${id}`, data);
export const deleteCreditDestination = (id: string) => api.delete(`${url.DELETE_CREDIT_DESTINATION}${id}`);

// Type Loan
export const getTypeLoanList = () => api.get(url.GET_TYPE_LOAN_LIST);
export const addTypeLoan = (data: any) => api.create(url.ADD_TYPE_LOAN, data);
export const updateTypeLoan = (id: string, data: any) => api.update(`${url.UPDATE_TYPE_LOAN}${id}`, data);
export const deleteTypeLoan = (id: string) => api.delete(`${url.DELETE_TYPE_LOAN}${id}`);

// Transfers

// wArranty Types
export const getWarrantyTypeList = () => api.get(url.GET_WARRANTY_TYPE_LIST);
export const addWarrantyType = (data: any) => api.create(url.ADD_WARRANTY_TYPE, data);
export const updateWarrantyType = (id: string, data: any) => api.update(`${url.UPDATE_WARRANTY_TYPE}${id}`, data);
export const deleteWarrantyType = (id: string) => api.delete(`${url.DELETE_WARRANTY_TYPE}${id}`);

// Warranties
export const getWarrantyList = () => api.get(url.GET_WARRANTY_LIST);
export const addWarranty = (data: any) => api.create(url.ADD_WARRANTY, data);
export const updateWarranty = (id: string, data: any) => api.update(`${url.UPDATE_WARRANTY}${id}`, data);
export const deleteWarranty = (id: string) => api.delete(`${url.DELETE_WARRANTY}${id}`);
export const getWarrantyByLoanApplicationId = (params: any) => api.get(url.GET_WARRANTY_BY_LOAN_APPLICATION_ID, params);

// Economic Activity Types
export const getEconomicActivityTypes = () => api.get(url.GET_ECONOMIC_ACTIVITIES_TYPE_LIST);
export const addEconomicActivityTypes = (data: any) => api.create(url.ADD_ECONOMIC_ACTIVITIES_TYPE, data);
export const updateEconomicActivityTypes = (id: string, data: any) => api.update(`${url.UPDATE_ECONOMIC_ACTIVITIES_TYPE}${id}`, data);
export const deleteEconomicActivityTypes = (id: string) => api.delete(`${url.DELETE_ECONOMIC_ACTIVITIES_TYPE}${id}`);

// Loan Application Status
export const getLoanApplicationStatusList = () => api.get(url.GET_LOAN_APPLICATION_STATUS_LIST);

//  Amortization Types
export const getAmortizationTypesList = () => api.get(url.GET_AMORTIZATION_TYPE_LIST);

// Patrimonial State
export const getPatrimonialStateList = () => api.get(url.GET_PATRIMONIAL_STATE_LIST);
export const addPatrimonialState = (data: any) => api.create(url.ADD_PATRIMONIAL_STATE, data);
export const updatePatrimonialState = (id: string, data: any) => api.update(`${url.UPDATE_PATRIMONIAL_STATE}${id}`, data);
export const deletePatrimonialState = (id: string) => api.delete(`${url.DELETE_PATRIMONIAL_STATE}${id}`);
export const getPatrimonialState = (id: string) => api.get(`${url.GET_PATRIMONIAL_STATE}${id}`);
export const getPatrimonialStateByLoanApplicationId = (params: any) => api.get(url.GET_PATRIMONIAL_STATE_BY_LOAN_APPLICATION_ID, params);

// Assets
export const getAssetList = () => api.get(url.GET_ASSET_LIST);
export const addAsset = (data: any) => api.create(url.ADD_ASSET, data);
export const updateAsset = (id: string, data: any) => api.update(`${url.UPDATE_ASSET}${id}`, data);
export const deleteAsset = (id: string) => api.delete(`${url.DELETE_ASSET}${id}`);
export const getAssetsByPaatrimonialStateId= (params: any) => api.get(url.GET_ASSET_BY_PATRIMONIAL_STATE, params);

// Liabilities
export const getLiabilityList = () => api.get(url.GET_LIABILITY_LIST);
export const addLiability = (data: any) => api.create(url.ADD_LIABILITY, data);
export const updateLiability = (id: string, data: any) => api.update(`${url.UPDATE_LIABILITY}${id}`, data);
export const deleteLiability = (id: string) => api.delete(`${url.DELETE_LIABILITY}${id}`);
export const getLiabilitiesByPatrimonialStateId= (params: any) => api.get(url.GET_LIABILITY_BY_PATRIMONIAL_STATE, params);

// Patrimonial Personal References
export const getPatrimonialPersonalReferencesList = () => api.get(url.GET_PATRIMONIAL_PERSONAL_REFERENCES_LIST);
export const addPatrimonialPersonalReferences = (data: any) => api.create(url.ADD_PATRIMONIAL_PERSONAL_REFERENCES, data);
export const updatePatrimonialPersonalReferences = (id: string, data: any) => api.update(`${url.UPDATE_PATRIMONIAL_PERSONAL_REFERENCES}${id}`, data);
export const deletePatrimonialPersonalReferences = (id: string) => api.delete(`${url.DELETE_PATRIMONIAL_PERSONAL_REFERENCES}${id}`);
export const getPatrimonialPersonalReferencesByPatrimonialStateId= (params: any) => api.get(url.GET_PATRIMONIAL_PERSONAL_REFERENCES_BY_STATE, params);

// Warranty File
export const getWarrantyDocuments = () => api.get(url.GET_WARRANTY_DOCUMENTS);
export const addWarrantyDocument = (data: any) => api.create(url.ADD_WARRANTY_DOCUMENT, data);
export const updateWarrantyDocument = (id: string, data: any) => api.update(`${url.UPDATE_WARRANTY_DOCUMENT}${id}`, data);
export const deleteWarrantyDocument = (id: string) => api.delete(`${url.DELETE_WARRANTY_DOCUMENT}${id}`);
export const getWarrantyDocumentByWarrantyId = (params: any) => api.get(url.GET_WARRANTY_DOCUMENT_BY_WARRANTY_ID, params);
export const uploadWarrantyFile = (id: string, data: FormData) => {
  return api.create(`${url.UPLOAD_WARRANTY_FILE}${id}/upload`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getWarrantyDocumentByFilename = (filename: string) =>
  api.get(`${url.GET_WARRANTY_DOCUMENT_BI_FILENAME}${filename}`, {}, { responseType: 'blob' });

// Transfers
export const getTransferList = (params: any) => api.get(url.GET_TRANSFER_LIST, params);
export const addTransfer = (data: any) => api.create(url.ADD_TRANSFER, data);